import React, { FC, memo } from 'react';

import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';
import AnalyticsService, { StreamBindFlowEventNameAMP } from 'application/services/AnalyticsService';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';

import { TEXTS } from './texts';
import { SelectPlayerFlowType } from '../../types';
import { useOnboardingContext } from '../../useOnboardingContext';
import { useOnboardingActionContext } from '../../useOnboardingActionContext';

import styles from './index.module.scss';

const DEVICE_IMAGE_PATH = '/assets/img/app/video/tv.png';

const DownloadTVAppModal: FC<ModalProps[ModalTypes.DOWNLOAD_TV_APP]> = ({ openModal, replaceModal, close }) => {
  const { flowType } = useOnboardingContext();
  const { clearCurrentPoint } = useOnboardingActionContext();

  const onDownloadClick = () => {
    AnalyticsService.event(StreamBindFlowEventNameAMP.STREAM_MOBILE_DOWNLOAD_CLICKED);
    replaceModal(ModalTypes.VIDEO_PLAYER_BIND, {});
  };

  const handleCancel = () => {
    if (flowType === SelectPlayerFlowType.CHANGE_DEVICE) {
      close();
      clearCurrentPoint();
      return;
    }

    openModal(ModalTypes.STREAM_STOP_BINDING_FLOW_WARNING, {});
  };

  return (
    <ModalScreen
      titlePlacement="left"
      onClose={handleCancel}
      className={styles.DownloadTVAppModal}
      contentClassName={styles.DownloadTVAppModalContent}
      title={TEXTS.MODAL_TITLE}
      containerActionButtonsClassName={styles.DownloadTVAppModalActionButtons}
      actionButtons={[
        <Button
          key="button_tv_app_download_modal_success"
          elementId="button_tv_app_download_modal_success"
          type={ButtonType.PRIMARY}
          onClick={onDownloadClick}>
          {TEXTS.SUCCESS_BUTTON}
        </Button>,
        <Button
          key="button_tv_app_download_modal_cancel"
          elementId="button_tv_app_download_modal_cancel"
          type={ButtonType.SECONDARY}
          onClick={() => {
            replaceModal(ModalTypes.CHOOSE_VIDEO_PLAYER, {});
          }}>
          {TEXTS.CANCEL_BUTTON}
        </Button>,
      ]}>
      <div className={styles.DownloadTVAppModalDownloadContent}>
        <img
          src={DEVICE_IMAGE_PATH}
          alt=""
          loading="lazy"
          className={styles.DownloadTVAppModalImageApp}
        />
      </div>
      <div className={styles.text}>
        <div className={styles.textSubtitle}>{TEXTS.SUBTITLE}</div>
        <div className={styles.textDescription}>
          <ol>
            <li>{TEXTS.TURN_ON}</li>
            <li>{TEXTS.SCROLL}</li>
            <li>{TEXTS.CHOOSE}</li>
            <li>{TEXTS.SELECT}</li>
          </ol>
        </div>
      </div>
    </ModalScreen>
  );
};

export default memo(DownloadTVAppModal);
